import type { AgencyModel } from '@urbanx/agx.agencies.client';

type AgencyLookupValue = Required<Pick<AgencyModel, 'name'>> &
  Pick<AgencyModel, 'logoUrl' | 'backgroundColor'>;

export const createAgencyLookup = (agencies?: AgencyModel[]) =>
  (agencies ?? []).reduce<Record<string, AgencyLookupValue>>((lookup, agency) => {
    if (agency.id && agency.name) {
      lookup[agency.id] = {
        name: agency.name,
        logoUrl: agency.logoUrl,
        backgroundColor: agency.backgroundColor,
      };
    }

    return lookup;
  }, {});

export const normalizeAgencyFilterState = (filters: {
  agencyValues?: unknown;
  agencyIds?: unknown;
  leadAgentIds?: unknown;
}) => {
  const agencyValues = filters.agencyValues ?? filters.agencyIds;
  const agencyIds = Array.isArray(agencyValues)
    ? agencyValues.filter((value): value is string => typeof value === 'string')
    : undefined;

  return {
    agencyIds,
    leadAgentIds:
      agencyIds?.length && Array.isArray(filters.leadAgentIds)
        ? filters.leadAgentIds.filter((value): value is string => typeof value === 'string')
        : undefined,
  };
};

export const getAgencyInitials = (agencyName?: string) => {
  if (!agencyName) return 'UA';

  return agencyName
    .split(' ')
    .map((name) => name.charAt(0).toUpperCase())
    .slice(0, 2)
    .join('');
};
